import { IconButton, Tooltip } from "@material-ui/core";
import { Star, StarBorder } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { useFormField } from "@clientUtils";

export function OnlyFavouritesChip() {
  const {
    field: { value },
    setFieldValue
  } = useFormField<boolean>("onlyFavourites");

  const selected = !!value;

  return (
    <Tooltip title={locale.onlyFavourites}>
      <IconButton onClick={() => setFieldValue(!selected)}>
        {selected ? <Star htmlColor="gold" /> : <StarBorder />}
      </IconButton>
    </Tooltip>
  );
}
